// extracted by mini-css-extract-plugin
export default {"txtname":"remove_txtname__55MMZ","modalBody":"remove_modalBody__hxrEN","btn":"remove_btn__owRey"};